import React from 'react';
import { useDispatch } from 'react-redux';
import styled from '../../components/styled';

import { CustomModal, SelectableRow } from '../../components';
import { ReportTemplate } from '../../services/dataModels';
import {
  selectReportTemplates,
  selectShiftLogModal,
  selectTemplateSelected,
  shiftLogActions,
} from '../../store';
import { AppDispatch } from '../../store/store';

const TemplatesModal = () => {
  const dispatch = useDispatch<AppDispatch>();

  const templates = selectReportTemplates.useHook();
  const modal = selectShiftLogModal.useHook();
  const selected = selectTemplateSelected.useHook();

  const handleSelection = (template: ReportTemplate) => {
    dispatch(
      shiftLogActions.templateSelected(
        selected?.templateName === template.templateName ? undefined : template,
      ),
    );
    handleModalDismissed();
  };

  const handleModalDismissed = () => {
    dispatch(shiftLogActions.modalChanged(false));
  };

  return (
    <CustomModal title={'Select a Template'} isVisible={modal} dismissModal={handleModalDismissed}>
      {templates?.map((template) => {
        return (
          <AssetOption key={template.templateName}>
            <SelectableRow
              title={template.displayName}
              subtitle={template.name}
              isSelected={selected?.templateName === template.templateName}
              onSelection={() => handleSelection(template)}
            />
          </AssetOption>
        );
      })}
    </CustomModal>
  );
};

export default TemplatesModal;

const AssetOption = styled.View``;
